<div *ngIf="isPageReady" id="printable-invoice" class="flex h-full">
  <div class="no-print flex grow flex-col border-2 p-2 shadow-lg" style="max-width: 8.5in; min-width: 8.5in">
    <div *ngIf="!manifest" #printableArea class="screen-p-20">
      <h2 *ngIf="!invoiceHeaders">Manifest {{ manifestId }} not found</h2>
      <h2 *ngIf="invoiceHeaders">No invoices found for manifest {{ manifestId }}</h2>
    </div>
    <div *ngIf="manifest" #printableArea class="screen-p-20 grow" style="overflow: auto">
      <div>
        <div uni-flex-row class="h1 mt-1">
          <span style="flex: auto">Unitec Distribution Systems</span>
          <span>Invoice Manifest</span>
        </div>
        <div uni-flex-row class="mt-1">
          <span style="flex: auto; font-style: italic">Innovative Apparel Distribution Systems<br />Tax Id: 52-0551098</span>
          <div style="text-align: right">
            <div *ngIf="manifestGroupId" class="h1" style="font-weight: 700">Manifest Invoice: {{ manifestGroupId }}</div>
            <div *ngIf="isPosted" class="h1" style="font-style: italic; color: gray">REPRINT</div>
          </div>
        </div>
        <div *ngIf="startDate != null" uni-flex-row class="mt-1">
          <span
            >Manifest '{{ manifest.manifestName }}' for Invoices posted between and including dates:
            {{ startDate | date: 'MM/dd/yyyy' }} and {{ endDate | date: 'MM/dd/yyyy' }}</span
          >
        </div>
        <div *ngIf="startDate == null" uni-flex-row class="mt-1">
          <span>Manifest '{{ manifest.manifestName }}' for Invoices posted before and including: {{ endDate | date: 'MM/dd/yyyy' }}</span>
        </div>

        <div uni-flex-row class="align-items-start mt-3">
          <uni-field uni-flex-item label="Bill To">
            <textarea pInputText rows="5" [ngModel]="getBillingAddress()" readonly="readonly"></textarea>
          </uni-field>
          <uni-field uni-flex-item label="Remit To">
            <textarea pInputText rows="5" [ngModel]="getUnitecAddress()" readonly="readonly"></textarea>
          </uni-field>
        </div>

        <table class="grid-print">
          <thead>
            <tr>
              <th class="col-left">Employee Name</th>
              <th class="col-left">Invoice No.</th>
              <th class="col-left">Invoice Date</th>
              <th class="col-right">Subtotal</th>
              <th class="col-right">Freight</th>
              <th class="col-right">Handling</th>
              <th class="col-right">Tax</th>
              <th class="col-right">Prepaid</th>
              <th class="col-right">Paid</th>
              <th class="col-right">Total</th>
            </tr>
          </thead>
          <tbody *ngIf="!isGroupedByProgramUserGroup">
            <ng-container *ngFor="let i of flatInvoices">
              <ng-container *ngTemplateOutlet="invoiceRow; context: { $implicit: i }"></ng-container>
            </ng-container>
            <ng-container *ngTemplateOutlet="totalsRow; context: { $implicit: totals, label: '', rowClass: 'bottom-row' }"></ng-container>
          </tbody>
          <tbody *ngIf="isGroupedByProgramUserGroup">
            <ng-container *ngFor="let g of invoiceGroups">
              <tr class="group-row">
                <td colspan="10">{{ g.programUserGroupName || 'No Program User Group' }}</td>
              </tr>
              <ng-container *ngFor="let i of g.invoices">
                <ng-container *ngTemplateOutlet="invoiceRow; context: { $implicit: i }"></ng-container>
              </ng-container>
              <ng-container
                *ngTemplateOutlet="totalsRow; context: { $implicit: g.totals, label: 'Subtotal', rowClass: 'bottom-row' }"
              ></ng-container>
            </ng-container>
            <ng-container *ngTemplateOutlet="totalsRow; context: { $implicit: totals, label: 'Grand Total', rowClass: 'grand-total-row' }"></ng-container>
          </tbody>
        </table>

        <ng-template #invoiceRow let-i>
          <tr>
            <td>{{ i.empName }}</td>
            <td>{{ i.invoiceId }}</td>
            <td>{{ i.invoiceDate }}</td>
            <td class="col-right">{{ i.subTotalAmt }}</td>
            <td class="col-right">{{ i.freightAmt }}</td>
            <td class="col-right">{{ i.orderHandlingAmt }}</td>
            <td class="col-right">{{ i.taxAmt }}</td>
            <td class="col-right">{{ i.prepaymentAmt }}</td>
            <td class="col-right">{{ i.paymentAmt }}</td>
            <td class="col-right">{{ i.totalAmt }}</td>
          </tr>
        </ng-template>

        <ng-template #totalsRow let-t let-label="label" let-rowClass="rowClass">
          <tr [class]="rowClass">
            <td colspan="3">{{ label }}</td>
            <td class="col-right">{{ t.subTotalAmt | currency }}</td>
            <td class="col-right">{{ t.freightAmt | currency }}</td>
            <td class="col-right">{{ t.orderHandlingAmt | currency }}</td>
            <td class="col-right">{{ t.taxAmt | currency }}</td>
            <td class="col-right">{{ t.prepaymentAmt | currency }}</td>
            <td class="col-right">{{ t.paymentAmt | currency }}</td>
            <td class="col-right">{{ t.totalAmt | currency }}</td>
          </tr>
        </ng-template>
      </div>

      <ng-container *ngIf="manifest.shouldIncludeInvoices">
        <ng-container *ngFor="let ih of invoiceHeaders">
          <div class="break"></div>
          <app-printable-invoice-content [invoiceHeader]="ih"></app-printable-invoice-content>
        </ng-container>
      </ng-container>
    </div>

    <div uni-flex-row class="accent no-print mt-4">
      <div *ngIf="!isPreview">
        <button pButton type="button" class="p-button-raised" [disabled]="!manifest" (click)="showPrintDialog()">
          <span>Print / Email</span>
        </button>
        <span style="margin-left: 8px">{{ email?.status }} {{ email?.statusTs | date: 'long' }}</span>
      </div>

      <div>
        <button pButton type="button" class="p-button-raised ml-2" icon="pi pi-arrow-left" (click)="goBack()">
          <span>Go Back</span>
        </button>
      </div>
    </div>
  </div>
  <p-confirmDialog></p-confirmDialog>
  <!-- / CENTER -->
</div>
